import { Component, Input, OnInit } from '@angular/core';
import { ActionSheetController } from '@ionic/angular';
import { Master } from 'src/app/models/Master';
import { AuthService } from 'src/app/services/auth.service';
import { MasterService } from 'src/app/services/modelService/master.service';
import { AlertService } from 'src/app/util/alert.service';
import { ToastService } from 'src/app/util/toast.service';

@Component({
  selector: 'app-master-box',
  templateUrl: './master-box.component.html',
  styleUrls: ['./master-box.component.scss'],
})
export class MasterBoxComponent implements OnInit {
  @Input() master: Master = new Master();
  childMasterList: Master[] = [];

  constructor(private masterService: MasterService, private actionSheetController: ActionSheetController,
    private alert: AlertService, private auth: AuthService, private toast: ToastService) { }

  ngOnInit() {
  }
  getChildList() {
    this.masterService.searchMaster([["parent_id", this.master.id]]).then((masterList: Master[]) => {
      this.childMasterList = masterList;
      this.master.showChild = true;
    })
  }
  async masterAction() {
    const actionSheet = await this.actionSheetController.create({
      header: 'Albums',
      buttons: [{
        text: 'Add',
        icon: 'add',
        handler: () => {
          this.add();
        }
      }, {
        text: 'edit',
        icon: 'pencil',
        handler: () => {
          this.edit();
        }
      },
      {
        text: 'Delete',
        icon: 'trash',
        handler: () => {
          this.delete();
        }
      }, {
        text: 'Cancel',
        icon: 'close',
        role: 'cancel',
        handler: () => {
        }

      }]
    });

    await actionSheet.present();
  }

  add() {
    this.alert.showTextAlert("Create Master", null, "Master Name").then((value) => {
      let master = new Master();
      master.type = this.masterService.casteMaster[this.master.level + 1];
      master.name = value;
      master.parent_id = this.master.id;
      master.level = this.master.level + 1;
      master.requested_by = this.auth.loggedInEmployee.id;
      master.category = "caste"
      this.masterService.saveMaster(master).then(() => {
        this.childMasterList.push(master);
      })
    })
  }

  edit() {
    this.alert.showTextAlert("Edit Master", null, "Master Name", null, null, this.master.name).then((value) => {
      if (value) {
        this.master.name = value;
        this.masterService.saveMaster(this.master).then(() => {
          this.toast.success("Master Updated successfully")
        });
      }
    });
  } 2

  delete() {
    this.masterService.searchMaster([["parent_id", this.master.id]]).then((childList: Master[]) => {
      this.childMasterList = childList;
      if (this.childMasterList.length > 0) {
        this.toast.error("Can't Delete " + this.master.name + ", Sub-Category is Available" + childList.length)
      } else {
        this.alert.showAlert("Delete Master", "Are You Sure Want To Delete", "Confirm").then((Confirm) => {
          this.masterService.deleteMaster(this.master).then(() => {
            this.toast.success("Deleted Successfully");
            window.location.reload();
          });
        });
      }
    });
  }
}
